import React from 'react';
import ReactDOM from 'react-dom';

import 'bulma/css/bulma.css';
import 'bulma-divider/dist/css/bulma-divider.min.css';
import './index.scss';
import { unregister } from './registerServiceWorker';

import App from './App';
import NoSupport from './screens/NoSupport/NoSupport';
import ContextProviders from './contexts/ContextProviders';

const AppWrapper = (
  <ContextProviders>
    <App />
  </ContextProviders>
);

const isIE = /* @cc_on!@ */ false || !!document.documentMode;
if (isIE) {
  ReactDOM.render(<NoSupport />, document.getElementById('root'));
} else {
  ReactDOM.render(AppWrapper, document.getElementById('root'));
}

unregister();
